angular.module('TetherApp').controller('LinkController', [
    '$window',
    'linkService',
    function (
        $window,
        linkService
    ) {
        let self = this;
        self.start = new Date();
        self.start.setMonth(self.start.getMonth() - 1);
        self.end = new Date();
        self.link = {
            append_tracking_information: true
        };
        // Fallback default text
        self.removeTrackingConfirmation = 'Are you sure you want to disable tracking information?';

        self.delete = function(linkId) {
            if($window.confirm(self.delinketeConfirmationText)) {
                linkService.deleteLink(linkId)
                    .then(onLinkDelete, onError);
            }
        };

        let onLinkDelete = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };

        self.appendTrackingToggle = function() {
            if (self.link.append_tracking_information == false) {
                if (! $window.confirm(self.removeTrackingConfirmation)) {
                    self.link.append_tracking_information = true;
                }
            }
        };

        // Activity
        self.setStart = function (dateString) {
            if (dateString == null) {
                self.start = null;
            } else {
                self.start = new Date(dateString);
            }
        };
        self.setEnd = function (dateString) {
            if (dateString == null) {
                self.end = null;
            } else {
                self.end = new Date(dateString);
            }
        };
    }
]);
